import React, { useEffect, useState } from "react";
import trans from "../../../../utils";
import { Input, TextAreaInput } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import {
	useGetPOIProjectsQuery,
	useGetPOIZonesQuery,
} from "../../../../Redux/service/POIS/POIs";
import { useGetAllformsQuery } from "../../../../Redux/service/Forms/Form";

export default function POIsInf({ addPOI }) {
	const statusOptions = [
		{ label: trans("Active"), value: true },
		{ label: trans("Inactive"), value: false },
	];
	const typeOptions = [
		{ label: trans("supermarket"), value: "supermarket" },
		{ label: trans("Shopping Area"), value: "shoppingarea" },
		{ label: trans("hospital"), value: "hospital" },
		{ label: trans("checkpoint"), value: "checkpoint" },
		{ label: trans("worksite"), value: "worksite" },
		{ label: trans("department"), value: "department" },
		{ label: trans("Project"), value: "project" },
		{ label: trans("building"), value: "zone" },
		{ label: trans("level"), value: "level" },
		{ label: trans("room"), value: "room" },
	];
	const { data: projects } = useGetPOIProjectsQuery(null, {
		skip: addPOI?.values?.type !== "zone",
	});
	const { data: zones } = useGetPOIZonesQuery(null, {
		skip: addPOI?.values?.type !== "building",
	});
	const { data: forms } = useGetAllformsQuery({
		page: 1,
		limit: 10000,
		queryString: "status=true",
	});
	const [label, setLabel] = useState();
	const [data, setData] = useState([]);
	useEffect(() => {
		if (addPOI?.values?.type === "zone") {
			setLabel("Project");
			setData(projects?.data);
		} else if (addPOI?.values?.type === "building") {
			setLabel("Building");
			setData(zones?.data);
		} else {
			setLabel("");
			setData([]);
		}
	}, [addPOI?.values?.type, projects?.data, zones?.data]);
	console.log("data", data);
	return (
		<>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("general information")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("POI Name")}
						type="text"
						placeholder={trans("Enter POI name")}
						id="name"
						name="name"
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.name}
						touched={addPOI.touched.name}
						value={addPOI.values.name || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Code")}
						type="text"
						placeholder={trans("Enter unique POI code")}
						id="code"
						name="code"
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						errors={addPOI.errors.code}
						touched={addPOI.touched.code}
						value={addPOI.values.code || ""}
					/>
				</div>
				{/**<div className="col-lg-6">
					<InputSelect
						label="status"
						name="status"
						id="status"
						options={statusOptions}
						placeholder={trans("Select Status")}
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(value) => addPOI.setFieldValue("status", value)}
						value={
							!addPOI.values.status ? trans("Inactive") : addPOI.values.status
						}
						allowClear={false}
					/>
				</div>**/}
				<div className="col-lg-6">
					<InputSelect
						label="Type"
						name="type"
						id="type"
						options={typeOptions}
						placeholder={trans("Select Type")}
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(value) => addPOI.setFieldValue("type", value)}
						touched={addPOI.touched.type}
						errors={addPOI.errors.type}
						value={addPOI.values.type ? addPOI.values.type : undefined}
						allowClear={false}
					/>
				</div>
				{label && (
					<div className="col-lg-6">
						<InputSelect
							label={label}
							name="parentId"
							id="parentId"
							options={data?.map((i) => ({ label: i?.name, value: i?.id }))}
							placeholder={trans(`Select ${label}`)}
							formstyle="form-input"
							onBlur={(e) => addPOI.handleBlur(e)}
							onChange={(value) => addPOI.setFieldValue("parentId", value)}
							value={addPOI.values.parentId}
							allowClear={false}
							touched={addPOI.touched.parentId}
							errors={addPOI.errors.parentId}
						/>
					</div>
				)}
				<div className="col-lg-6">
					<InputSelect
						label="Forms"
						name="forms"
						id="forms"
						options={forms?.data?.map((i) => ({
							label: i?.name,
							value: i?.id,
						}))}
						placeholder={trans(`Select forms`)}
						formstyle="form-input"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(val) => addPOI.setFieldValue("forms", val)}
						mode="multiple"
						value={addPOI.values.forms?.map((i) => {
							return i.formId || i;
						})}
						touched={addPOI.touched.forms}
						errors={addPOI.errors.forms}
					/>
				</div>
				<div className="col-lg-12">
					<TextAreaInput
						title={trans("Notes or Special Instructions")}
						placeholder={trans("Enter notes or special instructions")}
						id="notes"
						name="notes"
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(e) => addPOI.handleChange(e)}
						touched={addPOI.touched.notes}
						errors={addPOI.errors.notes}
						value={addPOI.values.notes || ""}
					/>
				</div>
			</div>
		</>
	);
}
